// //custom hook to clear store data, clear storage data, navigate to login
// // cannot use regular function because need useDispatch and useNavigate hooks

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { removeUser } from "../redux/userSlice.js";
import { clearCart } from "../redux/cartSlice.js";
import { clearStorage } from "./storageManager.js";
import { useContext, useCallback } from "react";
import { SocketContext } from "../contexts.js/SocketContext.js";

const useLogout = () => {
  const { socket, disconnectSocket } = useContext(SocketContext);

  // clear store and storage data
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isOnline, isAdmin, id } = useSelector((state) => state.user);

  const logout = useCallback(() => {
      dispatch(removeUser());
      dispatch(clearCart());
      clearStorage(["user", "token", "cart"]);
      if (isAdmin && isOnline && socket) {
        socket.emit("adminGoesOffline", id);
        disconnectSocket();
      }
      navigate("/login");
  }, [isAdmin, isOnline, id, socket, disconnectSocket, dispatch, navigate] );

  return logout;
};

export default useLogout;